export const DASHBOARD_URL_PREFIX = '/dashboard';

export const DASHBOARD_URL_REL = 'home';
export const DASHBOARD_URL = `${DASHBOARD_URL_PREFIX}/${DASHBOARD_URL_REL}`;

export const TIME_TABLE_URL_REL = 'time-table';
export const TIME_TABLE_URL = `${DASHBOARD_URL_PREFIX}/${TIME_TABLE_URL_REL}`;

export const CLASSROOM_URL_REL = 'classroom';
export const CLASSROOM_URL = `${DASHBOARD_URL_PREFIX}/${CLASSROOM_URL_REL}`;

export const SUBJECT_URL_REL = 'subject';
export const SUBJECT_URL = `${DASHBOARD_URL_PREFIX}/${SUBJECT_URL_REL}`;

export const ELECTIVE_SUBJECT_URL_REL = 'elective-subject';
export const ELECTIVE_SUBJECT_URL = `${DASHBOARD_URL_PREFIX}/${ELECTIVE_SUBJECT_URL_REL}`;

export const TEACHER_URL_REL = 'staff';
export const TEACHER_URL = `${DASHBOARD_URL_PREFIX}/${TEACHER_URL_REL}`;

export const SECTION_URL_REL = 'section';
export const SECTION_URL = `${DASHBOARD_URL_PREFIX}/${SECTION_URL_REL}`;

export const SUBJECT_CLASS_URL_REL = 'subject-class';
export const SUBJECT_CLASS_URL = `${DASHBOARD_URL_PREFIX}/${SUBJECT_CLASS_URL_REL}`;

export const STAFF_ABSENCE_URL_REL = 'staff-absence';
export const STAFF_ABSENCE_URL = `${DASHBOARD_URL_PREFIX}/${STAFF_ABSENCE_URL_REL}`;

export const STAFF_ATTENDANCE_URL_REL = 'staff-attendance';
export const STAFF_ATTENDANCE_URL = `${DASHBOARD_URL_PREFIX}/${STAFF_ATTENDANCE_URL_REL}`;

export const STAFF_SUBSTITUTE_URL_REL = 'staff-substitute';
export const STAFF_SUBSTITUTE_URL = `${DASHBOARD_URL_PREFIX}/${STAFF_SUBSTITUTE_URL_REL}`;

export const TEMPLATE_URL_REL = 'template';
export const TEMPLATE_URL = `${DASHBOARD_URL_PREFIX}/${TEMPLATE_URL_REL}`;

export const CREATE_TIME_TABLE_URL_REL = 'manage-time-table';
export const CREATE_TIME_TABLE_URL = `${DASHBOARD_URL_PREFIX}/${CREATE_TIME_TABLE_URL_REL}`;

export const TRAINER_URL_REL = 'trainer';
export const TRAINER_URL = `${DASHBOARD_URL_PREFIX}/${TRAINER_URL_REL}`;

export const MEMBER_URL_REL = 'member';
export const MEMBER_URL = `${DASHBOARD_URL_PREFIX}/${MEMBER_URL_REL}`;

export const FITNESS_PAYMENT_URL_REL = 'membership-payments';
export const FITNESS_PAYMENT_URL = `${DASHBOARD_URL_PREFIX}/${FITNESS_PAYMENT_URL_REL}`;


export const ACCOUNT_URL_REL = 'account';
export const ACCOUNT_URL = `${DASHBOARD_URL_PREFIX}/${ACCOUNT_URL_REL}`;

export const PROFILE_URL_REL = 'profile';
export const PROFILE_URL = `${DASHBOARD_URL_PREFIX}/${PROFILE_URL_REL}`;

export const MANAGE_SUBSCRIPTION_URL_REL = 'manage-subscription';
export const MANAGE_SUBSCRIPTION_URL = `${DASHBOARD_URL_PREFIX}/${MANAGE_SUBSCRIPTION_URL_REL}`;
